import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";

export const PLAN_STATUS_LABELS: Record<string, string> = {
  DRAFT: "Черновик",
  RUNNING: "Выполняется",
  DONE: "Выполнен",
  PARTIAL: "Частично",
  FAILED: "Упал",
  CANCELLED: "Отменён",
};

export const filterSchema: Schema = {
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 4,
    fullWidth: true,
    priority: "primary",
  },
  status: {
    label: "Статус",
    type: "select",
    xs: 12,
    md: 4,
    fullWidth: true,
    priority: "primary",
    options: [
      { label: "Все", value: "" },
      ...Object.entries(PLAN_STATUS_LABELS).map(([value, label]) => ({
        label,
        value,
      })),
    ],
  },
  problemsOnly: {
    label: "Только частичные и упавшие",
    type: "select",
    xs: 12,
    md: 4,
    fullWidth: true,
    priority: "primary",
    options: [
      { label: "Все", value: "" },
      { label: "Да", value: true },
    ],
  },
};
